export const GET_STATS = 'GET_STATS'
export const GET_FEED = 'GET_FEED'

export const GET_ACTIVE_USER = 'GET_ACTIVE_USER'
export const GET_ACTIVITIES_USER = 'GET_ACTIVITIES_USER'
export const GET_ATTENDANCE = 'GET_ATTENDANCE'
export const GET_NEWS = 'GET_NEWS'
export const GET_ACCOUNT = 'GET_ACCOUNT'
export const GET_DASHBOARD_FEE_STATS = 'GET_DASHBOARD_FEE_STATS'
export const GET_SCHEDULE = 'GET_SCHEDULE'

export const GET_BRANCH_LOGO = 'GET_BRANCH_LOGO'

export const GET_CURRENT_SESSION = 'GET_CURRENT_SESSION'

export const GET_USER_STATISTICS = 'GET_USER_STATISTICS'


export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES'
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES'
/** A preferences save refused before sending: too large for the column (no saga takes it). */
export const UPDATE_USER_PREFERENCES_REFUSED = 'UPDATE_USER_PREFERENCES_REFUSED'
